import { useEffect, useState } from 'preact/hooks';

export const AUTHOR_VARS = [
  'var(--st-author-1)',
  'var(--st-author-2)',
  'var(--st-author-3)',
  'var(--st-author-4)',
  'var(--st-author-5)',
  'var(--st-author-6)',
  'var(--st-author-7)',
  'var(--st-author-8)',
  'var(--st-author-9)',
  'var(--st-author-10)',
];

function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function useChorusProgress(animate: boolean, durationMs: number): number {
  const reduceMotion = prefersReducedMotion();
  const enabled = animate && !reduceMotion;
  const [t, setT] = useState(enabled ? 0 : 1);

  useEffect(() => {
    if (!enabled) {
      setT(1);
      return;
    }
    let raf = 0;
    const start = performance.now();
    const tick = (now: number) => {
      const p = Math.min(1, (now - start) / durationMs);
      const e = 1 - Math.pow(1 - p, 3);
      setT(e);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [enabled, durationMs]);

  return t;
}
